import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { BTN_PRIMARY, INPUT } from "@/lib/styles";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 flex items-center justify-center p-6 font-body">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <img src="/icon-192.png" alt="Notacora" className="w-10 h-10 rounded-lg" />
          <span className="font-heading font-semibold text-2xl tracking-tight">Notacora</span>
        </div>

        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <MailCheck size={40} className="mx-auto text-indigo-500 mb-4" />
            <h1 className="font-heading font-light text-2xl tracking-tight mb-2">Revisa tu correo</h1>
            <p className="font-body text-sm text-slate-500 dark:text-slate-400 mb-6">
              Si ese correo tiene una cuenta, te enviamos un enlace para restablecer tu contraseña. Caduca en 30 minutos.
            </p>
            <Link to="/login" className="text-indigo-500 hover:text-indigo-400 font-medium text-sm">Volver a iniciar sesión</Link>
          </div>
        ) : (
          <>
            <h1 className="font-heading font-light text-2xl tracking-tight mb-1 text-center">¿Olvidaste tu contraseña?</h1>
            <p className="font-body text-sm text-slate-500 dark:text-slate-400 mb-6 text-center">
              Escribe tu correo y te enviamos un enlace para crear una nueva.
            </p>
            <form onSubmit={submit} className="flex flex-col gap-4" data-testid="forgot-form">
              <input className={INPUT} type="email" placeholder="Correo electrónico" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" />
              {error && (
                <p className="font-body text-xs text-rose-500 bg-rose-500/10 border border-rose-500/20 rounded-lg px-3 py-2" data-testid="forgot-error">{error}</p>
              )}
              <button type="submit" className={`${BTN_PRIMARY} w-full py-3`} disabled={loading} data-testid="forgot-submit">
                {loading ? "Enviando..." : "Enviar enlace"}
              </button>
            </form>
            <div className="mt-6 text-center">
              <Link to="/login" className="inline-flex items-center gap-1 text-sm text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200">
                <ArrowLeft size={14} /> Volver
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
